import { PrinterProofComponent } from './components/printer-proof/printer-proof.component';
import { ConsentToPublishComponent } from './components/consent-to-publish/consent-to-publish.component';
import { CpNominationComponent } from './components/cp-nomination/cp-nomination.component';
import { RouterModule } from '@angular/router';
import { WorkflowTableGridComponent } from './components/workflow-table-grid/workflow-table-grid.component';
import { ToasterNotificationComponent } from './components/toaster-notification/toaster-notification.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { GroupCardComponent } from './components/group-card/group-card.component';
import { ButtonComponent } from './components/button/button.component';
import { InputTextboxComponent } from './components/input-textbox/input-textbox.component';
import { InputCheckboxComponent } from './components/input-checkbox/input-checkbox.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { InputTextareaComponent } from './components/input-textarea/input-textarea.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { PopUpHeaderComponent } from './components/pop-up-header/pop-up-header.component';
import { PopUpBodyComponent } from './components/pop-up-body/pop-up-body.component';
import { PopUpFooterComponent } from './components/pop-up-footer/pop-up-footer.component';
import { TableGridComponent } from './components/table-grid/table-grid.component';
import { FocusOutDirective } from './directives/focus-out.directive';
import { DatePipePipe } from './pipes/date-pipe.pipe';
import { InputFileComponent } from './components/input-file/input-file.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { BackNavigationBtnComponent } from './components/back-navigation-btn/back-navigation-btn.component';
import { SectionComponent } from './components/section/section.component';
import { ComponentSeperatorComponent } from './components/component-seperator/component-seperator.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FormHeaderComponent } from './components/form-header/form-header.component';
import { InputRadioButtonComponent } from './components/input-radio-button/input-radio-button.component';
import { MultiselectableDropdownComponent } from './components/multiselectable-dropdown/multiselectable-dropdown.component';
import { HighlightTextPipe } from './pipes/highlight-text.pipe';
import { DeleteConfirmationPopupComponent } from './components/delete-confirmation-popup/delete-confirmation-popup.component';
import { SearchSingleUserComponent } from './components/search-single-user/search-single-user.component';
import { SearchMultipleUserComponent } from './components/search-multiple-user/search-multiple-user.component';
import { SearchUserWithRoleComponent } from './components/search-user-with-role/search-user-with-role.component';
import { StickyTopDirective } from './directives/sticky-top.directive';
import { ConfirmationPopUpComponent } from './components/confirmation-pop-up/confirmation-pop-up.component';
import { AlertComponent } from './components/alert/alert.component';
import { StickyBottomBtnsComponent } from './components/sticky-bottom-btns/sticky-bottom-btns.component';
import { InputRadioBtnsComponent } from './components/input-radio-btns/input-radio-btns.component';
import { FullScreenPopupComponent } from './components/full-screen-popup/full-screen-popup.component';
import { ShowMoreNamesComponent } from './components/show-more-names/show-more-names.component';
import { DonutChartComponent } from './components/donut-chart/donut-chart.component';
import { ViewUserProfileComponent } from './components/view-user-profile/view-user-profile.component';
import { ViewAffiliationComponent } from './components/view-affiliation/view-affiliation.component';
import { ViewTrainingComponent } from './components/view-training/view-training.component';
import { ViewUploadComponent } from './components/view-upload/view-upload.component';
import { WorkflowFilterBarComponent } from './components/workflow-filter-bar/workflow-filter-bar.component';
import { CpQpReportComponent } from './cp-qp-report/cp-qp-report.component';
import { ViewProgressTrackerBtnComponent } from './components/view-progress-tracker-btn/view-progress-tracker-btn.component';
import { ImportExcelComponent } from './components/import-excel/import-excel.component';
import { ViewLogHistoryComponent } from './components/view-log-history/view-log-history.component';
import { ProgressTrackerStatusComponent } from './components/progress-tracker-status/progress-tracker-status.component';
import { UpdateActionPopUpComponent } from './components/update-action-pop-up/update-action-pop-up.component';
import { ReportingCyclesDropdownComponent } from './components/reporting-cycles-dropdown/reporting-cycles-dropdown.component';
import { PreviousYearPageComponent } from './components/previous-year-page/previous-year-page.component'

@NgModule({
  declarations: [SearchBarComponent,
    GroupCardComponent,
    ButtonComponent,
    InputTextboxComponent,
    InputCheckboxComponent,
    DropdownComponent,
    TabsComponent,
    InputTextareaComponent,
    LoaderComponent,
    PopUpComponent,
    PopUpHeaderComponent,
    PopUpBodyComponent,
    PopUpFooterComponent,
    ToasterNotificationComponent,
    TableGridComponent,
    FocusOutDirective,
    DatePipePipe,
    InputFileComponent,
    DragDropDirective,
    PageHeaderComponent,
    BackNavigationBtnComponent,
    SectionComponent,
    ComponentSeperatorComponent,
    BreadcrumbComponent,
    FormHeaderComponent,
    InputRadioButtonComponent,
    MultiselectableDropdownComponent,
    HighlightTextPipe,
    SearchSingleUserComponent,
    SearchMultipleUserComponent,
    SearchUserWithRoleComponent,
    DeleteConfirmationPopupComponent,
    StickyTopDirective,
    ConfirmationPopUpComponent,
    AlertComponent,
    StickyBottomBtnsComponent,
    InputRadioBtnsComponent,
    FullScreenPopupComponent,
    ShowMoreNamesComponent,
    DonutChartComponent,
    WorkflowTableGridComponent,
    ViewUserProfileComponent,
    ViewAffiliationComponent,
    ViewTrainingComponent,
    ViewUploadComponent,
    WorkflowFilterBarComponent,
    CpNominationComponent,
    ConsentToPublishComponent,
    PrinterProofComponent,
    CpQpReportComponent,
    ImportExcelComponent,
    ViewProgressTrackerBtnComponent,
    ViewLogHistoryComponent,
    ProgressTrackerStatusComponent,
    UpdateActionPopUpComponent,
    ReportingCyclesDropdownComponent,
    PreviousYearPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgbModule,
    DragDropModule,
  ],
  exports: [
    SearchBarComponent,
    GroupCardComponent,
    ButtonComponent,
    InputTextboxComponent,
    InputCheckboxComponent,
    DropdownComponent,
    TabsComponent,
    InputTextareaComponent,
    LoaderComponent,
    PopUpComponent,
    PopUpBodyComponent,
    PopUpHeaderComponent,
    PopUpFooterComponent,
    ToasterNotificationComponent,
    TableGridComponent,
    FocusOutDirective,
    DatePipePipe,
    InputFileComponent,
    DragDropDirective,
    BackNavigationBtnComponent,
    SectionComponent,
    PageHeaderComponent,
    ComponentSeperatorComponent,
    BreadcrumbComponent,
    FormHeaderComponent,
    InputRadioButtonComponent,
    MultiselectableDropdownComponent,
    SearchSingleUserComponent,
    SearchMultipleUserComponent,
    SearchUserWithRoleComponent,
    DeleteConfirmationPopupComponent,
    StickyTopDirective,
    ConfirmationPopUpComponent,
    AlertComponent,
    StickyBottomBtnsComponent,
    InputRadioBtnsComponent,
    FullScreenPopupComponent,
    HighlightTextPipe,
    ShowMoreNamesComponent,
    DonutChartComponent,
    WorkflowTableGridComponent,
    ViewUserProfileComponent,
    ViewAffiliationComponent,
    ViewTrainingComponent,
    ViewUploadComponent,
    WorkflowFilterBarComponent,
    CpNominationComponent,
    ConsentToPublishComponent,
    PrinterProofComponent,
    ImportExcelComponent,
    ViewProgressTrackerBtnComponent,
    ViewLogHistoryComponent,
    ProgressTrackerStatusComponent,
    UpdateActionPopUpComponent,
    ReportingCyclesDropdownComponent,
    PreviousYearPageComponent
  ],
  providers: [DatePipe],
})
export class SharedModule {
}

